import { Button } from "@/components/ui/button";
import { AnimatePresence, motion } from "framer-motion";
import { useTranslations } from "next-intl";
import React from "react";

type Props = {
  icon: React.ReactNode;
  title: string;
  children: React.ReactNode;
  clear?: () => void;
  showClear?: boolean;
};

const MotionButton = motion(Button);

const FilterWrapper: React.FC<Props> = ({
  icon,
  title,
  children,
  clear,
  showClear,
}) => {
  const t = useTranslations("search");
  return (
    <div className="google-anno-skip flex flex-col gap-2 w-full">
      <div className="flex flex-row gap-2 items-center justify-between">
        <div className="flex flex-row gap-1.5 items-center text-primary">
          {icon}
          <h3 className="text-sm font-medium ">{title}</h3>
        </div>

        <AnimatePresence>
          {clear && showClear && (
            <MotionButton
              initial={{ opacity: 0, scale: 0 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0 }}
              type="button"
              variant="outline"
              size="xs"
              onClick={clear}
            >
              {t("clear")}
            </MotionButton>
          )}
        </AnimatePresence>
      </div>
      {children}
    </div>
  );
};

export default FilterWrapper;
